<template>
  <div class="relative flex items-start">
    <div class="flex items-center h-5">
      <input
        :checked="modelValue"
        :name="name || label"
        type="checkbox"
        class="cursor-pointer form-checkbox h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
        :disabled="disabled"
        @change="$emit('update:modelValue', $event.target.checked)"
      />
    </div>
    <div class="ml-3 text-sm">
      <label :for="name || label" class="font-medium text-gray-700 block">{{ label }}</label>
      <p v-if="description" class="text-gray-500">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: Boolean,
    label: String,
    description: String,
    placeholder: String,
    optional: Boolean,
    disabled: Boolean,
    name: String,
  },
  emits: ['update:modelValue'],
};
</script>

<style>
.form-checkbox {
  cursor: pointer;
}
</style>
